module.exports = __webpack_public_path__ + "img/email.6a9b1fcd.png";